import initialState from "./initial.value";

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "user_data":
      return { ...state, user_data: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
